import imageBanner from './img/banner.png'
import imageTable from './img/table.jpg'
import { ProductProps } from '../../type'
import { ProductCategory, ProductTag } from '../../enum'

export const phgP510k0lnaM: ProductProps = {
  tag: ProductTag.ESS,
  category: ProductCategory.CommercialEnergyStorageSystems,
  pathName: 'phg-p510k0lna-m',
  banner: imageBanner,
  title: 'Smart Split-phase Hybrid Inverter\nPhG-P510K0L',
  description:
    'PhaseGreen PhG-P5-10KOLNA-M brings PV energy storage solutions to\nAmerican customers with safe performance and first-class quality',
  features: [
    {
      type: 'card-list',
      content: [
        {
          icon: 'safety',
          title: 'Friendly & flexible',
          description: [
            'Support multi-machine parallel connection',
            'Support multi-machine parallel mode sharing a battery pack',
            'Single-machine load capacity 100A;Supports 100% phase unbalanced output',
          ],
        },
        {
          icon: 'solution',
          title: 'Secure & Reliable',
          description: ['Passed UL 1741; IEEE 1547; UL1699B; FCC, CA Rule21; HECO Rule14H', 'Ingress protection IP65'],
        },
        {
          icon: 'inverter',
          title: 'Economic & efficient',
          description: [
            'Support parallel SOC equalization control and parallel current sharing control;',
            'Use split-phase topology and eliminate transformers to make higher efficiency;',
            'Support the diesel generator and the grid access at the same time;',
            'Integrate the On/Off-grid controller, Various energy management modes such as TOU, self use and battery priority',
          ],
        },
      ],
    },
  ],
  specImages: [imageTable],
}
